import Newsletter from '../components/template2/Newssletter';

new Vue({
    el: '#vue-footer',
    components: {
        Newsletter
    },
    data: {
        wldata: window.vueData.wldata,
        url_face: window.vueData.url_face,
        url_insta: window.vueData.url_insta,
        url_whats: window.vueData.url_whats,
        url_linkedin: window.vueData.url_linkedin,
        url_youtube: window.vueData.url_youtube || '', // 18/09/2026
        newss_email: '',
        menus: window.vueData.menus
    },
    methods: {
        openModalNewsletter () {
            this.$refs.newsletter.frmEmail = this.newss_email;
            this.$refs.newsletter.show();
        }
    }
});
